import styled, { css } from 'styled-components';
import { BaseMessage } from './BaseMessage';

export const SuccessMessage = styled(BaseMessage)`
  background: #42a880;
  color: #fff;
`;
